// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { TableSectorStaySummaryComponent } from './table-sector-stay-summary.component';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { StaySummaryModule } from 'libraries/component/booking-information/components/sectors/components/sectors-stay/stay-summary/stay-summary.module';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        BtnModule,
        StaySummaryModule,
        FontAwesomeModule,
    ],
    exports: [TableSectorStaySummaryComponent],
    declarations: [TableSectorStaySummaryComponent],
    providers: [],
})
export class TableSectorStaySummaryModule { }
